import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider } from './ThemeContext';
import MainLayout from './layout/MainLayout';
import Home from './pages/Home';
import Services from './pages/Services';
import Consulting from './pages/Consulting';
import Development from './pages/Development';
import Education from './pages/Education';
import NotFound from './pages/NotFound';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="services" element={<Services />} />
            <Route path="consulting" element={<Consulting />} />
            <Route path="development" element={<Development />} />
            <Route path="education" element={<Education />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
